import { render, staticRenderFns } from "./ModalEditMyProfile.vue?vue&type=template&id=3ba9be8c&scoped=true&"
import script from "./ModalEditMyProfile.vue?vue&type=script&lang=js&"
export * from "./ModalEditMyProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditMyProfile.vue?vue&type=style&index=0&id=3ba9be8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba9be8c",
  null
  
)

export default component.exports